// Backend API client. All calls use the shared origin (REACT_APP_BACKEND_URL)
// and include cookies for the httpOnly session.
const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

async function req(path, opts = {}) {
  const res = await fetch(`${API}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...opts,
  });
  if (!res.ok) {
    const err = new Error(`HTTP ${res.status}`);
    err.status = res.status;
    try {
      err.detail = (await res.json()).detail;
    } catch {
      err.detail = null;
    }
    throw err;
  }
  return res.json();
}

export const api = {
  exchangeSession: (sessionId) =>
    req('/auth/session', { method: 'POST', body: JSON.stringify({ session_id: sessionId }) }),
  me: () => req('/auth/me'),
  logout: () => req('/auth/logout', { method: 'POST' }),
  getProgress: () => req('/progress'),
  putProgress: (data) => req('/progress', { method: 'PUT', body: JSON.stringify({ data }) }),
  checkout: () => req('/payments/checkout', { method: 'POST' }),
  reconcile: () => req('/payments/reconcile', { method: 'POST' }),
  paymentStatus: (reference, paymentId) =>
    req(
      `/payments/status?reference=${encodeURIComponent(reference)}` +
        (paymentId ? `&payment_id=${encodeURIComponent(paymentId)}` : '')
    ),
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function goToGoogleLogin() {
  const redirectUrl = window.location.origin + '/';
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
